module.exports = __webpack_public_path__ + "media/images/top/top/bg_hero_pc-98b0e1232e7e8191cf16509b14a09478.png";